export enum FormStepId {
  CreditPurposeInfo = 'creditPurposeInfo',
  ContactsInfo = 'contactsInfo',
  PassportInfo = 'passportInfo',
  WorkplaceInfo = 'workplaceInfo',
  AdditionalInfo = 'additionalInfo',
}
